import './StoreUpgradePlan.css';
import PageHeader from '../../../../shared/components/layout/PageHeader';

const StoreUpgradePlan = () => (
  <section className="section store-upgrade-plan-shell">
    <PageHeader
      title="Upgrade Plan"
      description="Unlock advanced features and higher limits for your store."
    />
    <div className="card">
      <h3>Choose a plan that fits your store</h3>
      <p>Manage growth with priority support, advanced analytics, and team access.</p>
    </div>
  </section>
);

export default StoreUpgradePlan;
